import { Component, Input, OnInit } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { ValidationHeaderComponent } from '../validation-header/validation-header.component';

import { ValidatePatientMatchDetailsComponent } from '../validate-patient-match-details/validate-patient-match-details.component';
import { ValidatePatientMatchFormComponent } from '../validate-patient-match-form/validate-patient-match-form.component';

@Component({
    selector: 'app-validate-patient-match',
    templateUrl: './validate-patient-match.component.html',
    styleUrls: ['./validate-patient-match.component.scss'],
    imports: [ValidationHeaderComponent, ValidatePatientMatchDetailsComponent, ValidatePatientMatchFormComponent]
})
export class ValidatePatientMatchComponent implements OnInit {
  collapsed = false;

  @Input() patientAttachment: PatientAttachment;

  constructor() {}

  ngOnInit() {}

  onCollapseChange(collapsed) {
    this.collapsed = collapsed;
  }

  collapse() {
    this.collapsed = true;
  }

  expand() {
    this.collapsed = false;
  }
}
